// Use this file to override the default configuration

import { type PartialDeep } from 'type-fest';

import { type DefaultConfig } from './default.config';

export const defaultProdConfig: PartialDeep<DefaultConfig> = {
    consoleLogLevel: 'info'
};
